import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  DeleteDocument,
  FolderDocumentContains,
  FolderDocumentUpdate,
  FolderMarkAsFav,
  makeDocumentPinn,
  moveFolderData,
  uploadDocFile,
  versionHistoryListData,
} from "./DocumentService";
import moment from "moment";
import { debounce } from "lodash";
import AddDocument from "./AddDocumnet";
import CreateFolder from "./CreateFolder";
import MoveFolder from "./MoveFolder";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ErrorMessagePopup from "./ErrorMessagePopup";
import DocumentDragDrop from "./DragDrop";
import { BreadCrumb } from "primereact/breadcrumb";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import documentConfig from "../../../config/documentConfig";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";

const DocumentList = () => {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [isLoading, setIsloading] = useState(false);
  const { Id } = useParams();
  const [allDocumentData, setAllDocumentData] = useState([]);
  const [folderName, setFolderName] = useState();
  const [selectedDocumentId, setSelectedDocumentId] = useState(0);
  const [selectedMovedDocumentId, setDocumentId] = useState(0);
  const [renameFolder, setRenameFolder] = useState([]);
  const [docName, setDocName] = useState(renameFolder?.DocName || "");
  const toster = useContext(TostMsg);
  const [versionHistoryData, setVersionHistoryData] = useState([]);
  const [renameValidation, setRenameValidation] = useState(false);
  const [errorMessages, setErrorMessage] = useState("");
  const fileTypes = documentConfig;
  const [dropInFolderError, setDropInFolderMessage] = useState("");
  const [dropfolderData, setFolderData] = useState({});
  const [importantFolderData, setImportantFolderData] = useState([]);
  const history = useHistory();
  const [deleteErrorMessage, setDeleteConfirmErrorMessage] = useState(false);
  const [folderData, setOnlyFolderData] = useState([]);
  const [renameErrorMessage, setRenameErrorMessage] = useState(true);
  const [auditLogData, setAuditLogData] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [breadcrumb, setBreadcrumb] = useState([
    { id: 0, label: "Documents", LabelId: 0, GUID: "" },
  ]);
  const [isBookmarkedValue, setIsBookMarkedValue] = useState(0);
  const [navigateBack, setNavigateBack] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [DocumentHeading, setDocumentContent] = useState("");
  const [FolderId, setFolderId] = useState("");
  const [documentManage, setDocumentManage] = useState(false);
  const [documentPinned, setDocumentPinned] = useState(false);
  const [documentUpload, setDocumentUpload] = useState(false);

  useEffect(() => {
    const reload = sessionStorage.getItem("reload") === "true";

    if (reload) {
      getSideNavFolderList(0);
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem("reload", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    GetFolderDataByGUID(Id);
    permissionAccouncementList();
    GetMasterSystemAlertList();
  }, [Id]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (
        UserPermission.PermissionName == "Document.Manage" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentManage(true);
      }

      if (
        UserPermission.PermissionName == "Document.Pin" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentPinned(true);
      }

      if (
        UserPermission.PermissionName == "Document.Upload" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentUpload(true);
      }
    });
  };

  async function GetFolderDataByGUID(folderId) {
    const params = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: 0, // Number(FolderId),
      Search: "",
      Id: 0,
      GUID: folderId,
      BookMarkedOnly: isBookmarkedValue,
    };
    try {
      const responseData = await FolderDocumentContains(params);
      const data = responseData?.Data;

      setFolderId(data[0]?.Id);
      setTimeout(() => {
        getDocumentList("", data[0]?.Id);
      }, 1000);
    } catch (error) {}
  }

  useEffect(() => {
    const breadCrumbData = localStorage.getItem("breadcrumbs");
    if (breadCrumbData) {
      setBreadcrumb(JSON.parse(breadCrumbData));
    }
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "Document_Center") {
        setDocumentContent(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      history.push("/Documents", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  async function getDocumentList(searchValue, folderId) {
    setIsloading(true);
    const params = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: Number(folderId),
      Search: searchValue ? searchValue : "",
      Id: 0,
      GUID: "", // folderId,
      BookMarkedOnly: isBookmarkedValue,
    };
    try {
      const responseData = await FolderDocumentContains(params);
      const data =
        responseData?.Data.map((folder) => ({
          ...folder,
          isDraggingDropping: false,
          expandDropdown: false,
        })) || [];

      const currentFolder = data.filter(
        (item) => item?.LabelId !== Number(folderId),
      );

      const lastFolderName = breadcrumb[breadcrumb.length - 1];
      setFolderName(currentFolder[0]?.DocName || lastFolderName?.label);

      setAllDocumentData(
        data.filter((item) => item?.LabelId === Number(folderId)),
      );

      setImportantFolderData(
        data.filter(
          (item) =>
            item?.IsPinned === true && item?.LabelId === Number(folderId),
        ),
      );
      const reload = sessionStorage.getItem("reload")
        ? sessionStorage.getItem("reload")
        : false;

      if (!reload) {
        buildBreadcrumb(currentFolder, data);
      }

      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    } finally {
      sessionStorage.removeItem("reload");
    }
  }

  async function getSideNavFolderList(folderId) {
    const params = {
      Empid: userDetails?.EmpId,
      Type: 1,
      LabelId: Number(folderId),
      Search: "",
      Id: 0,
      GUID: "", //folderId,
      BookMarkedOnly: 0,
    };
    try {
      const responseData = await FolderDocumentContains(params);
      const data = responseData?.Data.filter(
        (item) => item?.DocTypeId === 101 && item?.LabelId === Number(folderId),
      );

      sessionStorage.setItem("reload", "true");

      if (Number(folderId) === 0) {
        setOnlyFolderData(data);
      } else {
        const updated = addChildren(folderData, Number(folderId), data);

        setOnlyFolderData(updated);
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.GetFolder);
    } finally {
    }
  }

  const addChildren = (data, parentId, children) => {
    return data.map((item) => {
      if (item.Id === parentId) {
        return { ...item, children };
      }
      if (item.children) {
        return {
          ...item,
          children: addChildren(item.children, parentId, children),
        };
      }
      return item;
    });
  };

  async function deleteDocument(isOverride) {
    const params = {
      Id: selectedDocumentId,
      IsOverride: isOverride,
    };

    try {
      const response = await DeleteDocument(params);
      setIsloading(false);

      if (response.StatusCode === 2000) {
        GetMasterSystemAlertList("DOc_Delete", 0);
        await getDocumentList("", FolderId ? Number(FolderId) : 0);
        setSelectedDocumentId(0);
      } else if (response.StatusCode === 2003) {
        setDeleteConfirmErrorMessage(response?.Message);
        const modalEl = document.getElementById("delete-doc-confirm");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      } else {
        setSelectedDocumentId(0);
      }
    } catch (error) {
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  }

  const handleSearchInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      setOnlyFolderData((prev) =>
        prev.map((item) => ({
          ...item,
        })),
      );
      sessionStorage.setItem("reload", "true");
      if (value) {
        getDocumentList(value, FolderId ? Number(FolderId) : 0);
      } else {
        getDocumentList("", FolderId ? Number(FolderId) : 0);
      }
    }, 800),
    [allDocumentData],
  );

  const closeCreateFolderPopup = (value) => {
    if (value === true) {
      document.querySelector("#CreateFolder .btn-close")?.click();
      getDocumentList("", FolderId ? Number(FolderId) : 0);
    }
  };

  const closeMoveFolderPopup = (value) => {
    if (value?.close === true && value?.success === 1) {
      document.querySelector("#move-doc .btn-close")?.click();
      getDocumentList("", FolderId ? Number(FolderId) : 0);
    }
  };

  async function FolderRename() {
    let documentName = "";
    if (renameFolder?.DocTypeId === 101) {
      documentName = docName;
    } else {
      documentName = `${docName}${renameFolder?.DocName?.slice(
        renameFolder?.DocName?.lastIndexOf("."),
      )}`;
    }
    const params = {
      Id: renameFolder ? renameFolder?.Id : 0,
      LabelId: renameFolder ? Number(renameFolder?.LabelId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: renameFolder ? renameFolder?.DocPath : "",
      Name: documentName ? documentName : "",
      Desc: renameFolder ? renameFolder?.DocDesc : "",
      DocTypeId: renameFolder ? renameFolder?.DocTypeId : 0,
      IsOverride: 0,
    };
    if (docName) {
      try {
        const response = await FolderDocumentUpdate(params);
        setIsloading(false);
        if (response?.StatusCode === 2000) {
          if (params?.DocTypeId === 101) {
            GetMasterSystemAlertList("Folder_Renamed", 0);
          } else {
            GetMasterSystemAlertList("Doc_Rename", 0);
          }
          sessionStorage.setItem("reload", "true");

          setRenameFolder([]);
          setDocName("");
          getDocumentList("", FolderId ? Number(FolderId) : 0);
          setRenameErrorMessage("");
          document.querySelector("#Rename .btn-close")?.click();
        } else {
          setRenameErrorMessage(response?.Message);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.PostFolder);
        setIsloading(false);
      }
    } else {
      setRenameValidation(true);
    }
  }

  async function versionHistoryList(documentId) {
    setIsloading(true);
    let req = {
      DocId: documentId,
    };

    try {
      const response = await versionHistoryListData(req);
      setVersionHistoryData(
        response?.Data.filter((item) => item?.IsVersion === 1),
      );
      setAuditLogData(response?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const makeUnPin = async (Folder, value, docTypeId) => {
    const params = {
      OrgId: userDetails?.OrgId,
      LabelId: Folder?.Id,
    };
    try {
      setIsloading(true);
      const responseData = await makeDocumentPinn(params);
      if (value === false) {
        if (docTypeId === 101) {
          GetMasterSystemAlertList("Folder_Pinned", 0);
        } else {
          GetMasterSystemAlertList("Doc_Pinned", 0);
        }
      } else {
        if (docTypeId === 101) {
          GetMasterSystemAlertList("Folder_Unpinned", 0);
        } else {
          GetMasterSystemAlertList("Doc_Unpinned", 0);
        }
      }

      sessionStorage.setItem("reload", "true");

      if (responseData) {
        await getDocumentList(
          "",
          Folder?.LabelId ? Number(Folder?.LabelId) : 0,
        );
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.MakeUnPin);
    } finally {
      setIsloading(false);
    }
  };

  const navigateFolderPage = (folder) => {
    history.push(`/DocumentList/${folder?.GUID}`);
  };

  const navigateSideNav = (folder) => {
    GetFolderDataByGUID(folder?.GUID);
    history.push(`/DocumentList/${folder?.GUID}`);
  };

  const navigateFilePage = (folderId) => {
    history.push(`/Document/View/${folderId}`);
  };

  const handleDragEnter = (e, folder) => {
    e.preventDefault();

    setAllDocumentData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
    setImportantFolderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
  };

  const handleDragLeave = (e, folder) => {
    e.preventDefault();

    setAllDocumentData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
    setImportantFolderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
  };

  const handleDragOver = (e, folder) => {
    e.preventDefault();

    setAllDocumentData((prev) =>
      prev.map((f) => ({
        ...f,
        isDraggingDropping: f.Id === folder?.Id,
      })),
    );
    setImportantFolderData((prev) =>
      prev.map((f) => ({
        ...f,
        isDraggingDropping: f.Id === folder?.Id,
      })),
    );
  };

  const handleDrop = async (event, document) => {
    event.preventDefault();
    setAllDocumentData((prev) =>
      prev.map((f) =>
        f.Id === document?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
    setImportantFolderData((prev) =>
      prev.map((f) =>
        f.Id === document?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );

    if (event.dataTransfer.getData("files")) {
      const files = JSON.parse(event.dataTransfer.getData("files"));

      if (files?.Id === document.Id) {
        toster.current.error("Item can not be moved in same folder.");
      } else {
        if (files) {
          let req = {
            OrgId: userDetails?.OrgId,
            LabelId: document ? document.Id : 0,
            Id: files.Id,
            IsOverride: 0,
            LoggedInUserId: userDetails?.Id,
          };
          try {
            const responseData = await moveFolderData(req);
            sessionStorage.setItem("reload", "true");
            getDocumentList("", FolderId ? Number(FolderId) : 0);

            if (responseData?.StatusCode === 2000) {
              if (files?.DocTypeId === 101) {
                GetMasterSystemAlertList("Folder_move", 0);
              } else {
                GetMasterSystemAlertList("Doc_Move", 0);
              }
            } else if (responseData?.StatusCode === 2003) {
              closeMoveFolderPopup({ close: true, success: 0 });
              setErrorMessage({
                Message: responseData?.Message,
                FolderId: req.Id,
                SelectedFolderId: req.LabelId,
              });
            } else {
              toster.current.error(responseData?.Message);
            }
          } catch (error) {
            toster.current.error(error.error.Message);
          }
        }
      }
    } else {
      if (document.DocTypeId != 101) {
        toster.current.error("Item can not be moved in same folder.");
      } else {
        handleDropIntoFolder(event, document);
      }
    }
  };

  const handleDropIntoFolder = async (e, document) => {
    e.preventDefault();

    const items = e.dataTransfer.items;
    const allFiles = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        const files = await traverseFileTree(entry);

        allFiles.push(files);

        await processDragDrop(files, document ? document?.Id : 0, 0, false);
      }
    }
    toster.current.success("Document uploaded successfully");
  };

  function traverseFileTree(item, path = "") {
    return new Promise((resolve) => {
      if (item.isFile) {
        item.file((file) => {
          resolve({
            name: file.name,
            type: "file",

            file,
          });
        });
      } else if (item.isDirectory) {
        const dirReader = item.createReader();

        dirReader.readEntries(async (entries) => {
          let results = [];
          for (let entry of entries) {
            const nestedFiles = await traverseFileTree(entry);

            results.push(nestedFiles);
          }

          resolve({
            name: item.name,
            type: "directory",
            DocTypeId: 101,
            results,
          });
        });
      }
    });
  }

  async function onDragDropFile({ folder, folderId, isOverride }) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: folder?.docPath,
      Name: folder?.fileName,
      Desc: "",
      DocTypeId: folder?.docTypeId,
      IsOverride: isOverride ? isOverride : 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        sessionStorage.setItem("reload", "true");

        getDocumentList("", folderId ? Number(folderId) : 0);
        setDropInFolderMessage("");
        setFolderData({});
      } else {
        setFolderData({ folder: folder, folderId: folderId, type: "file" });
        setDropInFolderMessage(response?.Message);
        const modalEl = document.getElementById("DropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function uploadFolderDocFile(file, folderId, isOverride) {
    setIsloading(true);

    if (file) {
      const formData = new FormData();

      formData.append("files", file);

      let params = {
        UploadType: UploadFile_KEYS?.Document,
        RefId: 0,
      };

      try {
        const response = await uploadDocFile(params, formData);

        const docPathURL = response?.Data;

        const docPath = docPathURL[0];
        const fileName = docPath.split(/[/\\]/).pop();
        const ext = fileName.split(".").pop();
        let docTypeId = 0;
        if (["jpeg", "jpg", "png"].includes(ext)) docTypeId = 106;
        else if (ext === "pdf") docTypeId = 102;
        else if (["xls", "xlsx", "csv"].includes(ext)) docTypeId = 103;
        else if (["doc", "docx"].includes(ext)) docTypeId = 104;
        else if (["ppt", "pptx"].includes(ext)) docTypeId = 105;
        else if (ext === "mp4") docTypeId = 107;
        else if (ext === "mp3") docTypeId = 108;
        else if (["zip", "rar"].includes(ext)) docTypeId = 109;
        else docTypeId = 110;

        await onDragDropFile({
          folder: {
            docPath: docPath,
            fileName: fileName,
            docTypeId: docTypeId,
          },

          folderId,
          isOverride,
        });

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      } finally {
      }
    } else {
      setIsloading(false);
    }
  }

  async function onDragDropFolder(folder, folderId) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: "",
      Name: folder?.name,
      Desc: "",
      DocTypeId: folder?.DocTypeId,
      IsOverride: folder?.IsOverride || 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        sessionStorage.setItem("reload", "true");

        getDocumentList("", folderId ? Number(folderId) : 0);
        setDropInFolderMessage("");
        setFolderData({});
      } else if (response?.StatusCode === 2003) {
        setFolderData({ folder: folder, folderId: folderId, type: "folder" });
        setDropInFolderMessage(response?.Message);

        const modalEl = document.getElementById("DropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      return response;
    } catch (error) {}
  }

  async function processDragDrop(
    folder,
    folderId,
    isOverride = 0,
    isRootOverride = false,
  ) {
    try {
      if (folder.type === "file" && isOverride === 0) {
        await uploadFolderDocFile(folder.file, folderId, isOverride);
      } else {
        await onDragDropFile({ folder: folder, folderId, isOverride });
      }

      if (folder.type === "directory") {
        const response = await onDragDropFolder(
          { ...folder, IsOverride: isOverride },
          folderId,
        );
        if (response?.StatusCode === 2000) {
          for (const child of folder.results) {
            await processDragDrop(child, response?.Data?.Id, 0, false);
          }

          if (isRootOverride) {
            isOverride = 0;
          }
        }
      }
    } catch (error) {}
  }

  async function markAsFavourite(documentId) {
    setIsloading(true);
    const params = {
      DocId: documentId,
    };
    try {
      const response = await FolderMarkAsFav(params);
      if (response) {
        sessionStorage.setItem("reload", "true");

        await getDocumentList("", FolderId ? Number(FolderId) : 0);
        setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  const dropFileFolder = (value) => {
    if (value.close === true && value.success === 1) {
      sessionStorage.setItem("reload", "true");

      getDocumentList("", FolderId ? Number(FolderId) : 0);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const onBreadcrumbClick = (index) => {
    const selected = breadcrumb[index];

    if (breadcrumb.length !== index + 1) {
      setBreadcrumb((prev) => prev.slice(0, index));
    }

    if (selected?.id === 0) {
      history.push("/Documents");
    } else {
      history.push(`/DocumentList/${selected.GUID}`);
    }
  };

  const handleFavouriteChange = (e) => {
    const value = e.target.checked ? 1 : 0;
    setIsBookMarkedValue(value);

    setBreadcrumb(JSON.parse(localStorage.getItem("breadcrumbs")));
  };

  useEffect(() => {
    setTimeout(() => {
      markAsFavouriteList();
    }, 1000);
  }, [isBookmarkedValue]);

  const markAsFavouriteList = async () => {
    sessionStorage.setItem("reload", "true");
    await getDocumentList("", FolderId ? Number(FolderId) : 0);
  };

  const navigateToBackPage = () => {
    setBreadcrumb((prev) => {
      if (prev.length <= 2) {
        history.push("/Documents");
        return prev;
      }

      const newBreadcrumb = prev.slice(0, -1);
      const last = newBreadcrumb[newBreadcrumb.length - 1];

      setBreadcrumb(newBreadcrumb);

      history.push(`/DocumentList/${last.GUID}`);
    });
  };

  function buildBreadcrumb(folder, allFolders) {
    if (!folder || folder.length === 0) return;

    const reload = sessionStorage.getItem("reload") === "true";

    if (reload) {
      const savedBreadcrumb = localStorage.getItem("breadcrumbs");
      if (savedBreadcrumb) {
        setBreadcrumb(JSON.parse(savedBreadcrumb));
      }
      return;
    }

    setBreadcrumb((prev) => {
      const exists = prev.find((item) => item.id === folder[0]?.Id);

      if (exists) return prev;

      const updated = [
        ...prev,
        {
          id: folder[0]?.Id,
          label: folder[0]?.DocName,
          LabelId: folder[0]?.LabelId,
          GUID: folder[0]?.GUID,
        },
      ];

      localStorage.setItem("breadcrumbs", JSON.stringify(updated));

      return updated;
    });
  }

  useEffect(() => {
    const saved = localStorage.getItem("breadcrumbs");
    if (saved) {
      setBreadcrumb(JSON.parse(saved));
    } else {
      setBreadcrumb([{ id: 0, label: "Documents", LabelId: 0, GUID: "" }]);
    }
  }, []);

  const setRenameDocValue = () => {
    if (renameFolder?.DocTypeId === 101) {
      return docName;
    } else {
      const dotIndex = docName.lastIndexOf(".");
      return dotIndex !== -1 ? docName.slice(0, dotIndex) : docName;
    }
  };

  const [activeFolders, setActiveFolders] = useState({});

  const renderFolders = (folders) => {
    return folders.map((folder) => (
      <div
        key={folder.Id}
        className={`sidebar-item 
  ${folder?.FolderCount > 0 ? "has-submenu" : ""} 
  ${activeFolders[folder.Id] ? "active" : ""}
`}
      >
        <a
          className={`sidebar-link ${folder?.FolderCount > 0 ? "toggle" : ""}`}
          title={folder.DocName}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (folder?.FolderCount > 0) {
              if (!folder.children) {
                getSideNavFolderList(folder?.Id);
              }

              setActiveFolders((prev) => ({
                ...prev,
                [folder.Id]: !prev[folder.Id],
              }));
            }
          }}
        >
          <div onClick={() => navigateSideNav(folder)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-folder2"
              viewBox="0 0 16 16"
            >
              <path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" />
            </svg>{" "}
            {folder.DocName.slice(0, 15)}
            {folder?.DocName.length > 15 && <span>...</span>}
          </div>
          {folder.FolderCount > 0 && <span className="arrow">▶</span>}
        </a>
        {activeFolders[folder.Id] && (
          <div className="submenu">
            {folder.children?.length > 0 && renderFolders(folder.children)}
          </div>
        )}
      </div>
    ));
  };

  return (
    <div>
      <div className="container-fluid   position-relative px-3">
        <div className="row team-directories">
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="row">
                <div className="col-lg-2 p-0 documentory-bx">
                  <div class="dashboard-nav">
                    <div className="top-sidebar-head">
                      <h5 title={folderName}>
                        {folderName?.slice(0, 12)}
                        {folderName?.length > 12 && <span>...</span>}{" "}
                      </h5>
                      <div className="back-login-btn text-end c-pointer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-arrow-left"
                          viewBox="0 0 16 16"
                          onClick={() => navigateToBackPage()}
                        >
                          <path
                            fillRule="evenodd"
                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                          />
                        </svg>{" "}
                      </div>
                    </div>

                    <nav className="sidebar document-sidbar">
                      {renderFolders(folderData)}
                    </nav>
                  </div>
                </div>

                <div className="col-lg-10">
                  <div className="px-5 document-file-content-area">
                    <div className="form-head row align-items-start documentory-bx12">
                      <div className="col-lg-7">
                        {breadcrumb?.length > 0 && (
                          <nav className="breadcrumb">
                            {breadcrumb.map((item, index) => (
                              <span
                                key={index}
                                className="breadcrumb-item"
                                onClick={() => onBreadcrumbClick(index)}
                              >
                                <a
                                  className={
                                    index < breadcrumb.length - 1
                                      ? "c-pointer"
                                      : " "
                                  }
                                  title={item?.label}
                                >
                                  {item?.label?.slice(0, 10)}{" "}
                                  {item?.label?.length > 10 && <span>...</span>}
                                </a>

                                {index < breadcrumb.length - 1 && " "}
                              </span>
                            ))}
                          </nav>
                        )}

                        <p className="mb-0 text-muted fs-15">
                          {DocumentHeading}
                        </p>
                      </div>
                      <div className="rightside-tabs col-lg-5">
                        <div className="col-lg-8">
                          <div className="d-flex align-items-center">
                            <div className="form-check form-switch me-3">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onChange={handleFavouriteChange}
                              />
                              <label
                                className="form-check-label fs-7 ms-0 mb-0"
                                for="flexSwitchCheckChecked"
                              >
                                Favourites
                              </label>
                            </div>

                            <div className="actionbutton-tickets">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Search"
                                onChange={handleSearchInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        {documentUpload && (
                          <div class="dropdown documents-dropdown">
                            <button
                              className="add-newticket me-2"
                              type="button"
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                className="bi bi-plus"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                              </svg>
                            </button>
                            <ul
                              class="dropdown-menu documentory-bx"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item c-pointer"
                                  data-bs-toggle="modal"
                                  data-bs-target="#CreateFolder"
                                >
                                  New Folder
                                </a>
                              </li>

                              <li>
                                <Link
                                  to={`/BulkUploadDocument/${Id}`}
                                  className="dropdown-item c-pointer"
                                >
                                  Upload Files
                                </Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-12 mt-2">
                      {importantFolderData?.length > 0 && (
                        <div className=" document-area documentory-bx">
                          <h3 className="top-title">Importants</h3>

                          <div className="files-block-area">
                            {importantFolderData?.map((folder, index) => (
                              <div
                                className={
                                  folder?.DocTypeId === 101
                                    ? `document-file-box ${
                                        folder?.isDraggingDropping
                                          ? "drag-folder-active"
                                          : ""
                                      }`
                                    : `files-all-block ${
                                        folder?.isDraggingDropping
                                          ? "drag-folder-active"
                                          : ""
                                      }`
                                }
                                onDragLeave={(e) => handleDragLeave(e, folder)}
                                onDragOver={(e) => handleDragOver(e, folder)}
                                onDrop={(e) => handleDrop(e, folder)}
                                onClick={(e) => e.preventDefault()}
                              >
                                <div
                                  className="sub-files-folder-area"
                                  key={index}
                                >
                                  {folder?.DocTypeId !== 101 ? (
                                    <div
                                      className="folder-box c-pointer"
                                      onClick={() => {
                                        if (folder?.DocTypeId === 102) {
                                          navigateFilePage(folder?.GUID);
                                        } else {
                                          window.open(folder.DocPath, "_blank");
                                        }
                                      }}
                                    >
                                      <img
                                        src={
                                          fileTypes.find(
                                            (f) =>
                                              f.ext ===
                                              folder?.DocPath?.split(/[/\\]/)
                                                .pop()
                                                .split(".")
                                                .pop()
                                                .toLowerCase(),
                                          )?.icon ||
                                          "/images/document/otherFileIcon.png"
                                        }
                                        className="img-fluid"
                                      />
                                    </div>
                                  ) : (
                                    <div
                                      className="folder-box c-pointer"
                                      onClick={() => {
                                        navigateFolderPage(folder);
                                      }}
                                    >
                                      <img
                                        src="/images/document/folder-4.png"
                                        className="img-fluid"
                                      />
                                      <div className="item-fd">
                                        <span>{folder?.DocCount}</span>
                                      </div>
                                    </div>
                                  )}

                                  <div className="content-area">
                                    <div
                                      className="c-pointer"
                                      onClick={() => {
                                        if (folder?.DocTypeId === 101) {
                                          navigateFolderPage(folder);
                                        } else if (folder?.DocTypeId === 102) {
                                          navigateFilePage(folder?.GUID);
                                        } else {
                                          window.open(folder.DocPath, "_blank");
                                        }
                                      }}
                                    >
                                      <h5 title={folder?.DocName}>
                                        {folder?.DocName?.slice(0, 15)}
                                        {folder?.DocName?.length > 15 && (
                                          <span>...</span>
                                        )}
                                      </h5>
                                      <p>
                                        {" "}
                                        {moment(folder?.CreatedDate).format(
                                          "MMM DD YYYY",
                                        )}{" "}
                                      </p>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center">
                                      <div className="d-flex align-items-center favourite-icon">
                                        <div className="document-hover">
                                          {folder?.IsBookMarkedByMe === 0 ? (
                                            <a
                                              className="like-button me-2"
                                              onClick={() =>
                                                markAsFavourite(folder?.Id)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="13"
                                                height="13"
                                                fill="currentColor"
                                                className="bi bi-heart"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                                              </svg>
                                            </a>
                                          ) : (
                                            <button
                                              className="btn btn-sm px-1"
                                              type="button"
                                              style={{ color: "red" }}
                                              onClick={() =>
                                                markAsFavourite(folder?.Id)
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="13"
                                                height="13"
                                                fill="currentColor"
                                                className="bi bi-heart-fill"
                                                viewBox="0 0 16 16"
                                              >
                                                <path
                                                  fill-rule="evenodd"
                                                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                                />
                                              </svg>
                                            </button>
                                          )}

                                          {documentManage &&
                                            folder?.IsEdit === 1 && (
                                              <a
                                                className="c-pointer me-1"
                                                draggable
                                                onDragStart={(e) => {
                                                  e.dataTransfer.setData(
                                                    "files",
                                                    JSON.stringify(folder),
                                                  );
                                                }}
                                                onDragEnter={(e) =>
                                                  handleDragEnter(e, folder)
                                                }
                                                onDragOver={(e) =>
                                                  handleDragOver(e, folder)
                                                }
                                                onDragLeave={(e) =>
                                                  handleDragLeave(e, folder)
                                                }
                                                onDrop={(e) =>
                                                  handleDrop(e, document)
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="13"
                                                  height="13"
                                                  fill="currentColor"
                                                  class="bi bi-arrows-move"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                                                  />
                                                </svg>
                                              </a>
                                            )}

                                          <div class="dropdown documents-dropdown text-dark">
                                            <button
                                              className="btn-link bg-transparent p-0 text-dark"
                                              type="button"
                                              id="user-edit-drop"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="13"
                                                height="13"
                                                fill="currentColor"
                                                class="bi bi-three-dots-vertical"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                              </svg>
                                            </button>
                                            <ul
                                              class="dropdown-menu"
                                              aria-labelledby="user-edit-drop"
                                            >
                                              {documentPinned && (
                                                <li>
                                                  <a
                                                    class="dropdown-item c-pointer"
                                                    onClick={() =>
                                                      makeUnPin(
                                                        folder,
                                                        folder?.IsPinned,
                                                        folder?.DocTypeId,
                                                      )
                                                    }
                                                  >
                                                    {folder?.IsPinned ===
                                                    true ? (
                                                      <>
                                                        <img
                                                          src="/images/document/important-icon.png"
                                                          className="document-dropdown-icon"
                                                        />{" "}
                                                        <span>Unpin</span>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <img
                                                          src="/images/document/unimportant-icon.png"
                                                          className="document-dropdown-icon"
                                                        />{" "}
                                                        <span>Pin to top</span>
                                                      </>
                                                    )}
                                                  </a>
                                                </li>
                                              )}
                                              {documentManage &&
                                                folder?.IsEdit === 1 && (
                                                  <>
                                                    <li>
                                                      <a
                                                        class="dropdown-item c-pointer"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#Rename"
                                                        onClick={() => {
                                                          setRenameFolder(
                                                            folder,
                                                          );
                                                          setDocName(
                                                            folder?.DocName,
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src="/images/document/edit-icon.png"
                                                          className="document-dropdown-icon"
                                                        />{" "}
                                                        <span>Rename</span>
                                                      </a>
                                                    </li>

                                                    <li>
                                                      <a
                                                        data-bs-target="#move-doc "
                                                        data-bs-toggle="modal"
                                                        className="dropdown-item c-pointer"
                                                        onClick={() =>
                                                          setDocumentId(
                                                            folder?.Id,
                                                          )
                                                        }
                                                      >
                                                        <img
                                                          src="/images/document/move-icon.png"
                                                          className="document-dropdown-icon"
                                                        />{" "}
                                                        <span>Move to</span>
                                                      </a>
                                                    </li>
                                                  </>
                                                )}

                                              {folder?.DocTypeId !== 101 && (
                                                <li>
                                                  <a
                                                    onClick={() =>
                                                      versionHistoryList(
                                                        folder?.Id,
                                                      )
                                                    }
                                                    data-bs-target="#version_history"
                                                    data-bs-toggle="modal"
                                                    className="dropdown-item c-pointer"
                                                  >
                                                    <img
                                                      src="/images/document/version history.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>
                                                      {" "}
                                                      Version History
                                                    </span>
                                                  </a>
                                                </li>
                                              )}

                                              <li>
                                                <a
                                                  onClick={() =>
                                                    versionHistoryList(
                                                      folder?.Id,
                                                    )
                                                  }
                                                  data-bs-target="#audit_log"
                                                  data-bs-toggle="modal"
                                                  className="dropdown-item c-pointer"
                                                >
                                                  <img
                                                    src="/images/document/audit logs.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Audit Logs</span>
                                                </a>
                                              </li>

                                              {documentManage &&
                                                folder?.IsEdit === 1 && (
                                                  <li>
                                                    <a
                                                      data-bs-target="#delete-doc"
                                                      data-bs-toggle="modal"
                                                      className="dropdown-item c-pointer"
                                                      onClick={() =>
                                                        setSelectedDocumentId(
                                                          folder?.Id,
                                                        )
                                                      }
                                                    >
                                                      <img
                                                        src="/images/document/delete-icon.png"
                                                        className="document-dropdown-icon"
                                                      />{" "}
                                                      <span>Delete</span>
                                                    </a>
                                                  </li>
                                                )}
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    {documentUpload && (
                      <DocumentDragDrop
                        FolderId={FolderId}
                        onDropFolder={(value) => dropFileFolder(value)}
                        errorMessage={(value) => {
                          setErrorMessage(value);
                        }}
                      />
                    )}
                    <div className="document-detail-area documentory-bx">
                      <div
                        className="table-responsive"
                        style={{
                          minHeight: "300px",
                        }}
                      >
                        <table class="table table-file-info folder-doc">
                          <thead>
                            <tr>
                              <th scope="col">File/Folder</th>

                              <th scope="col"></th>

                              <th scope="col" className="text-end"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {allDocumentData?.length !== 0 ? (
                              allDocumentData?.map((document, index) => (
                                <tr
                                  key={index}
                                  className={`${
                                    document?.isDraggingDropping
                                      ? "table-drag-folder-active"
                                      : ""
                                  }`}
                                  onDragOver={(e) =>
                                    handleDragOver(e, document)
                                  }
                                  onDrop={(e) => handleDrop(e, document)}
                                  onDragEnter={(e) =>
                                    handleDragEnter(e, document)
                                  }
                                  onDragLeave={(e) =>
                                    handleDragLeave(e, document)
                                  }
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="document-img me-2">
                                        {document?.DocTypeId === 101 ? (
                                          <img
                                            src="/images/document/folders.png"
                                            alt=""
                                          />
                                        ) : (
                                          <img
                                            src={
                                              fileTypes.find(
                                                (f) =>
                                                  f.ext ===
                                                  document?.DocPath?.split(
                                                    /[/\\]/,
                                                  )
                                                    .pop()
                                                    .split(".")
                                                    .pop()
                                                    .toLowerCase(),
                                              )?.icon ||
                                              "/images/document/otherFileIcon.png"
                                            }
                                            className="img-fluid"
                                          />
                                        )}
                                      </div>
                                      <div className="name-file">
                                        <a
                                          className="c-pointer"
                                          onClick={() => {
                                            if (document?.DocTypeId === 101) {
                                              navigateFolderPage(document);
                                            } else if (
                                              document?.DocTypeId === 102
                                            ) {
                                              navigateFilePage(document?.GUID);
                                            } else {
                                              window.open(
                                                document?.DocPath,
                                                "_blank",
                                              );
                                            }
                                          }}
                                        >
                                          <h5 title={document?.DocName}>
                                            {document?.DocName?.slice(0, 25)}
                                            {document?.DocName?.length > 25 && (
                                              <span>...</span>
                                            )}
                                          </h5>
                                        </a>

                                        <p className="mb-0">
                                          {document?.DocCount}{" "}
                                          {document?.DocCount > 1 ? (
                                            <span>items</span>
                                          ) : (
                                            <span>item</span>
                                          )}{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {moment(
                                      document?.CreatedDate.split("T")[0],
                                    ).format("MMM DD YYYY")}{" "}
                                    by{" "}
                                    <div className="document-by-profile">
                                      <LazyImage
                                        alt={document?.ModifiedByName}
                                        src={document?.ModifiedProfileImage}
                                        width="32"
                                      />
                                    </div>
                                    <span>{document?.ModifiedByName}</span>
                                  </td>
                                  <td>
                                    <div className="d-flex button-group-area justify-content-end align-items-center">
                                      <div className="document-hover">
                                        {documentManage &&
                                          document?.IsEdit === 1 && (
                                            <>
                                              <a
                                                className="c-pointer"
                                                draggable
                                                onDragStart={(e) => {
                                                  e.dataTransfer.setData(
                                                    "files",
                                                    JSON.stringify(document),
                                                  );
                                                }}
                                                onDragEnter={(e) =>
                                                  handleDragEnter(e, document)
                                                }
                                                onDragLeave={(e) =>
                                                  handleDragLeave(e, document)
                                                }
                                                onDragOver={(e) =>
                                                  handleDragOver(e, document)
                                                }
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  class="bi bi-arrows-move"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                                                  />
                                                </svg>
                                              </a>
                                            </>
                                          )}

                                        {document?.IsBookMarkedByMe === 0 ? (
                                          <a
                                            className="like-button"
                                            onClick={() =>
                                              markAsFavourite(document?.Id)
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              className="bi bi-heart"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                                            </svg>
                                          </a>
                                        ) : (
                                          <button
                                            className="btn btn-sm px-1"
                                            type="button"
                                            style={{ color: "red" }}
                                            onClick={() =>
                                              markAsFavourite(document?.Id)
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="13"
                                              height="13"
                                              fill="currentColor"
                                              className="bi bi-heart-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                              />
                                            </svg>
                                          </button>
                                        )}
                                      </div>

                                      <div class="dropdown documents-dropdown text-dark">
                                        <button
                                          className="btn-link btn bg-transparent p-0 text-dark"
                                          type="button"
                                          id="user-edit-drop"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="13"
                                            height="13"
                                            fill="currentColor"
                                            class="bi bi-three-dots-vertical"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                          </svg>
                                        </button>
                                        <ul
                                          class="dropdown-menu"
                                          aria-labelledby="user-edit-drop"
                                        >
                                          {documentPinned && (
                                            <li>
                                              <a
                                                class="c-pointer dropdown-item"
                                                onClick={() =>
                                                  makeUnPin(
                                                    document,
                                                    document?.IsPinned,
                                                    document?.DocTypeId,
                                                  )
                                                }
                                              >
                                                {document?.IsPinned === true ? (
                                                  <>
                                                    <img
                                                      src="/images/document/important-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Unpin</span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <img
                                                      src="/images/document/unimportant-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Pin to top</span>
                                                  </>
                                                )}
                                              </a>
                                            </li>
                                          )}
                                          {documentManage &&
                                            document?.IsEdit === 1 && (
                                              <>
                                                <li>
                                                  <a
                                                    className="c-pointer dropdown-item"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#Rename"
                                                    onClick={() => {
                                                      setRenameFolder(document);
                                                      setDocName(
                                                        document?.DocName,
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="/images/document/edit-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Rename</span>
                                                  </a>
                                                </li>

                                                <li>
                                                  <a
                                                    data-bs-target="#move-doc"
                                                    data-bs-toggle="modal"
                                                    className="c-pointer dropdown-item"
                                                    onClick={() =>
                                                      setDocumentId(
                                                        document?.Id,
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src="/images/document/move-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Move to</span>
                                                  </a>
                                                </li>
                                              </>
                                            )}

                                          <li>
                                            {document?.DocTypeId !== 101 && (
                                              <>
                                                <a
                                                  onClick={() =>
                                                    versionHistoryList(
                                                      document?.Id,
                                                    )
                                                  }
                                                  data-bs-target="#version_history"
                                                  data-bs-toggle="modal"
                                                  className="c-pointer dropdown-item"
                                                >
                                                  <img
                                                    src="/images/document/version history.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Version History</span>
                                                </a>
                                              </>
                                            )}
                                          </li>

                                          <li>
                                            <a
                                              onClick={() =>
                                                versionHistoryList(document?.Id)
                                              }
                                              data-bs-target="#audit_log"
                                              data-bs-toggle="modal"
                                              className="c-pointer dropdown-item"
                                            >
                                              <img
                                                src="/images/document/audit logs.png"
                                                className="document-dropdown-icon"
                                              />{" "}
                                              <span> Audit Logs</span>
                                            </a>
                                          </li>

                                          {documentManage &&
                                            document?.IsEdit === 1 && (
                                              <li>
                                                <a
                                                  onClick={() =>
                                                    setSelectedDocumentId(
                                                      document?.Id,
                                                    )
                                                  }
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#deleteDocument"
                                                  className=" c-pointer dropdown-item"
                                                >
                                                  <img
                                                    src="/images/document/delete-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Delete</span>
                                                </a>
                                              </li>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <div className="notfound">
                                <img src="/images/no-data-found/tickets-not-found.png" />
                                <p> No data found</p>
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* =============Delete Confirmation Popup======= */}
                    </div>

                    <div className="modal fade" id="delete-doc-confirm">
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content delete-holiday">
                          <div className="modal-header">
                            <img
                              src="/images/org-img/leave/popup-backimg.png"
                              className="backimg"
                            />
                            <div className="img">
                              <img src="/images/org-img/leave/trash.png" />
                            </div>
                          </div>
                          <div className="modal-body text-center">
                            <p>{deleteErrorMessage}</p>
                          </div>
                          <div className="modal-footer m-auto">
                            <button
                              type="button"
                              className="cancelbtn-click"
                              data-bs-dismiss="modal"
                              onClick={() => setSelectedDocumentId(0)}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="deletebtn-click"
                              data-bs-dismiss="modal"
                              onClick={() => deleteDocument(1)}
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade "
                      id="deleteDocument"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content delete-holiday">
                          <div className="modal-header">
                            <img
                              src="/images/org-img/leave/popup-backimg.png"
                              className="backimg"
                            />
                            <div className="img">
                              <img src="/images/org-img/leave/trash.png" />
                            </div>
                          </div>
                          <div className="modal-body text-center">
                            <h3 className="modal-title">
                              Document Deletion Confirmation
                            </h3>
                            <p>
                              Are you sure you want to delete this document?
                            </p>
                          </div>
                          <div className="modal-footer m-auto">
                            <button
                              type="button"
                              className="cancelbtn-click"
                              data-bs-dismiss="modal"
                              onClick={() => setSelectedDocumentId(0)}
                            >
                              Close
                            </button>
                            <button
                              type="button"
                              className="deletebtn-click"
                              data-bs-dismiss="modal"
                              onClick={() => deleteDocument(0)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========Create folder============ */}
                    <div
                      className="modal fade "
                      id="CreateFolder"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content p-0">
                          <div className="modal-header">
                            <h5 className="modal-title">Create Folder</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              onClick={() => setResetKey((k) => k + 1)}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <CreateFolder
                              key={resetKey}
                              onFolderClose={(value) =>
                                closeCreateFolderPopup(value)
                              }
                            ></CreateFolder>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========Move folder============ */}
                    <div
                      className="modal fade "
                      id="move-doc"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Move to</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              onClick={() => setDocumentId(0)}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <MoveFolder
                              errorMessage={(value) => {
                                setErrorMessage(value);
                              }}
                              onMoveFolderClose={(value) =>
                                closeMoveFolderPopup(value)
                              }
                              selectedMovedDocumentId={selectedMovedDocumentId}
                              FolderId={FolderId}
                            ></MoveFolder>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========Rename folder============ */}
                    <div
                      className="modal fade "
                      id="Rename"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content p-0">
                          <div className="modal-header">
                            <h5 className="modal-title">Rename</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              onClick={() => {
                                setRenameFolder([]);
                                setDocName("");
                                setRenameErrorMessage("");
                              }}
                            ></button>
                          </div>

                          <div className="modal-body">
                            <div className="row">
                              <div className="col-md-12 mb-5">
                                <label>
                                  Name<i className="inValidError">*</i>
                                </label>
                                <div className="d-flex align-items-center">
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={setRenameDocValue()}
                                    onChange={(e) => {
                                      setDocName(e.target.value);
                                      setRenameValidation(
                                        e.target.value ? false : true,
                                      );
                                    }}
                                  />

                                  {renameFolder?.DocTypeId !== 101 && (
                                    <span>
                                      {renameFolder?.DocName?.slice(
                                        renameFolder?.DocName?.lastIndexOf("."),
                                      )}
                                    </span>
                                  )}
                                </div>
                                {renameValidation && (
                                  <div className="invalid-feedback">
                                    Name is required.
                                  </div>
                                )}

                                {renameErrorMessage && (
                                  <div className="invalid-feedback">
                                    {renameErrorMessage}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-12">
                                <div className="btns-grp">
                                  <button
                                    type="button"
                                    className="cancelbtn-click"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="savebtn-click btn-purple rounded"
                                    onClick={FolderRename}
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ==========Version History ============ */}
                    <div
                      className="modal fade "
                      id="version_history"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Version History</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                            ></button>
                          </div>

                          <div className="modal-body">
                            <div className="row">
                              <div className="col-md-12">
                                <table class="table table-file-info">
                                  <thead>
                                    <tr>
                                      <th scope="col">No.</th>
                                      <th scope="col">Comment</th>
                                      <th scope="col">FileName</th>
                                      <th scope="col">By</th>
                                      <th scope="col">Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {versionHistoryData?.map(
                                      (history, index) => (
                                        <tr>
                                          <td>{history?.VersionNumber}</td>
                                          <td>{history?.Comment}</td>
                                          <td>
                                            {" "}
                                            <a
                                              href={`${history?.DocPath}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {history?.Name}
                                            </a>
                                          </td>
                                          <td>
                                            <img
                                              src={
                                                history?.ModifiedProfileImage
                                              }
                                              onError={handleImageError}
                                              className="rounded-lg me-2"
                                              width="18"
                                              alt=""
                                            />
                                            {history?.ModifiedByName}
                                          </td>
                                          <td>
                                            {moment(
                                              history?.ModifiedDate,
                                            ).format("MMM DD YYYY")}{" "}
                                            {new Date(
                                              history?.ModifiedDate,
                                            ).toLocaleTimeString([], {
                                              hour: "numeric",
                                              minute: "2-digit",
                                            })}
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ===========Audit Logs========= */}
                    <div
                      className="modal fade "
                      id="audit_log"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered modal-lg"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Audit Logs</h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                            ></button>
                          </div>

                          <div className="modal-body">
                            <div className="row">
                              <div className="col-md-12">
                                <table class="table table-file-info">
                                  <thead>
                                    <tr>
                                      <th scope="col">Comment</th>

                                      <th scope="col">By</th>
                                      <th scope="col">Date</th>

                                      {/* <th scope="col">Status</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {auditLogData?.map((history, index) => (
                                      <tr>
                                        <td>{history?.Comment}</td>

                                        <td>{history?.ModifiedByName}</td>
                                        <td>
                                          {moment(history?.ModifiedDate).format(
                                            "MMM DD YYYY",
                                          )}{" "}
                                          {new Date(
                                            history?.ModifiedDate,
                                          ).toLocaleTimeString([], {
                                            hour: "numeric",
                                            minute: "2-digit",
                                          })}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="DropErrorMessagePopup"
                      tabIndex="-1"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content p-0">
                          <div className="modal-header">
                            <h5 className="modal-title error-alert">
                              Error Alert
                            </h5>
                            <button
                              type="button"
                              className="btn-close p-0"
                              data-bs-dismiss="modal"
                              //   onClick={onCloseErrorPopup}
                            ></button>
                          </div>

                          <div className="modal-body text-center">
                            <span className="text-purple">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                fill="currentColor"
                                class="bi bi-file-earmark mb-2"
                                viewBox="0 0 16 16"
                              >
                                <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                              </svg>
                            </span>
                            <p className="error-message">{dropInFolderError}</p>

                            <div className="text-center d-flex ">
                              {dropfolderData?.type === "file" && (
                                <>
                                  <button
                                    type="button"
                                    className="cancelbtn-click"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                      // setIsOverride(2);
                                      processDragDrop(
                                        dropfolderData.folder,
                                        dropfolderData.folderId,
                                        1,
                                        true,
                                      );
                                    }}
                                  >
                                    Replace
                                  </button>
                                </>
                              )}

                              <button
                                type="button"
                                className="savebtn-click btn-purple rounded"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  // setIsOverride(2);
                                  processDragDrop(
                                    dropfolderData.folder,
                                    dropfolderData.folderId,
                                    2,
                                    true,
                                  );
                                }}
                              >
                                Keep Both
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ErrorMessagePopup
                      errorMessage={errorMessages}
                      onCloseErrorPopup={() => {
                        setErrorMessage("");
                        sessionStorage.setItem("reload", "true");
                        getDocumentList("", FolderId ? Number(FolderId) : 0);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default DocumentList;
